import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../utils/translations';
import { Card, Button, Badge } from './UI';

const InterestSubmissionsViewer = () => {
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);
  const [submissions, setSubmissions] = useState([]);

  useEffect(() => {
    loadSubmissions();
  }, []);

  const loadSubmissions = () => {
    const data = JSON.parse(localStorage.getItem('interest_submissions') || '[]');
    setSubmissions(data);
  };

  const downloadCSV = () => {
    if (submissions.length === 0) {
      alert('No hay registros para exportar');
      return;
    }

    // Create CSV content
    const headers = ['Nombre', 'Email', 'Teléfono', 'Región', 'Rol', 'Idioma Preferido', 'Mensaje', 'Quiere Actualizaciones', 'Fecha'];
    const rows = submissions.map(sub => [
      sub.fullName,
      sub.email,
      sub.phone,
      sub.region,
      sub.role,
      sub.preferredLanguage,
      sub.message || '',
      sub.wantsUpdates ? 'Sí' : 'No',
      new Date(sub.submittedAt).toLocaleString(),
    ]);

    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.map(cell => `"${cell}"`).join(','))
    ].join('\n');

    // Download file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `liberado_interest_submissions_${new Date().toISOString().split('T')[0]}.csv`;
    link.click();
  };

  return (
    <Card className="mt-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-xl font-bold">
          📋 {t('interestRegistration')} ({submissions.length})
        </h3>
        <Button onClick={downloadCSV} disabled={submissions.length === 0}>
          📥 Descargar CSV
        </Button>
      </div>

      {submissions.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          <p>No hay registros de interés todavía</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-2 text-left">Nombre</th>
                <th className="p-2 text-left">Email</th>
                <th className="p-2 text-left">Teléfono</th>
                <th className="p-2 text-left">Región</th>
                <th className="p-2 text-left">Rol</th>
                <th className="p-2 text-left">Fecha</th>
              </tr>
            </thead>
            <tbody>
              {submissions.map((sub, idx) => (
                <tr key={idx} className="border-b hover:bg-gray-50">
                  <td className="p-2">{sub.fullName}</td>
                  <td className="p-2">{sub.email}</td>
                  <td className="p-2">{sub.phone}</td>
                  <td className="p-2">{sub.region}</td>
                  <td className="p-2">
                    <Badge variant="info">{t(sub.role)}</Badge>
                  </td>
                  <td className="p-2 text-xs text-gray-500">
                    {new Date(sub.submittedAt).toLocaleDateString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
};

export default InterestSubmissionsViewer;